import { FC } from 'react';
import styled from 'styled-components';

type DownloadButtonProps = {
  onClick: () => void
  buttonText: string
}
const Button = styled.button`
  border: 1px solid #00000033;
  padding: 1rem 1.7rem;
  background: #fff;
  border: 1px solid #00000033;
  font-weight: 500;
  font-size: 15px;
  color: #545454;
  border-radius: 90px;
  display: flex;
  align-items: center;
  grid-gap: 10px;
  transition: all 0.2s ease-in;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  white-space: nowrap;
  cursor: pointer;
  &:hover {
    border-color: ${({ theme }) => theme.colors.primary1};
  }
`
const DownloadIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.4405 8.8999C20.0405 9.2099 21.5105 11.0599 21.5105 15.1099V15.2399C21.5105 19.7099 19.7205 21.4999 15.2505 21.4999H8.74047C4.27047 21.4999 2.48047 19.7099 2.48047 15.2399V15.1099C2.48047 11.0899 3.93047 9.2399 7.47047 8.9099" stroke="#4A9462" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M12 2V14.88" stroke="#4A9462" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M15.3484 12.6499L11.9984 15.9999L8.64844 12.6499" stroke="#4A9462" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
)

export const DownloadButton: FC<DownloadButtonProps> = ({ buttonText, onClick }) => {
  return <Button type='button' onClick={onClick}>{DownloadIcon} {buttonText}</Button>
}